// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/screens/Competitions/index.css
// module id = 2582
// module chunks = 0